/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsProvisionalConfig } from '../../config/settings.config';
export interface ISettingsProvisionalPluginMethods extends IPluginMethodMap {
  getSettingsProvisionalSync(args?: any): any;
}

export class SettingsProvisionalPlugin implements IAgentPlugin {
  readonly methods: ISettingsProvisionalPluginMethods;

  constructor() {
    this.methods = {
      getSettingsProvisionalSync: this.getSettingsProvisionalSync.bind(this),
    };
  }

  getSettingsProvisionalSync(args?: any) {
    return {
      settings: settingsProvisionalConfig,
    };
  }
}
